/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1FeedbackFeedbackidLangsAvailableLanguages200,
  GetApiV1FeedbackFeedbackidLangsAvailableLanguages401,
  GetApiV1FeedbackFeedbackidLangsAvailableLanguages404,
  GetApiV1FeedbackFeedbackidLangsAvailableLanguages500,
  GetApiV1FeedbackFeedbackidLangsAvailableLanguagesPathParams,
  GetApiV1FeedbackFeedbackidLangsAvailableLanguagesQueryResponse,
} from "../../types/feedbackIdiomasController/GetApiV1FeedbackFeedbackidLangsAvailableLanguages.ts";
import { dropDownListStringKeyViewModelSchema } from "../dropDownListStringKeyViewModelSchema.ts";

export const getApiV1FeedbackFeedbackidLangsAvailableLanguagesPathParamsSchema =
  z.object({
    feedbackId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1FeedbackFeedbackidLangsAvailableLanguagesPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1FeedbackFeedbackidLangsAvailableLanguages200Schema =
  z.array(
    z.lazy(() => dropDownListStringKeyViewModelSchema),
  ) as unknown as ToZod<GetApiV1FeedbackFeedbackidLangsAvailableLanguages200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1FeedbackFeedbackidLangsAvailableLanguages401Schema =
  z.any() as unknown as ToZod<GetApiV1FeedbackFeedbackidLangsAvailableLanguages401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1FeedbackFeedbackidLangsAvailableLanguages404Schema =
  z.any() as unknown as ToZod<GetApiV1FeedbackFeedbackidLangsAvailableLanguages404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1FeedbackFeedbackidLangsAvailableLanguages500Schema =
  z.any() as unknown as ToZod<GetApiV1FeedbackFeedbackidLangsAvailableLanguages500>;

export const getApiV1FeedbackFeedbackidLangsAvailableLanguagesQueryResponseSchema =
  z.lazy(
    () => getApiV1FeedbackFeedbackidLangsAvailableLanguages200Schema,
  ) as unknown as ToZod<GetApiV1FeedbackFeedbackidLangsAvailableLanguagesQueryResponse>;
